import styled from "styled-components";

export const Container = styled.div`
  /* display: flex; */
  /* justify-content: center; */
  margin-top: 48px;
  margin: 12px 24px 12px 24px;
`;
